/* eslint-disable  multiline-ternary */
import { ReactNode, useContext, useMemo, useRef, useState, useEffect } from 'react';
import { FormikProps } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import { setValiditedTrue, setValiditedFalse } from 'src/store/validation/validationSlice';
import { RootState } from 'src/store/store';
import { useNavigate } from 'react-router-dom';
import { Card, LeftMenu, Typography, Button, ConfirmModal } from 'src/components/common';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { TCreateIdeaRequest, TEditIdeaRequest } from 'src/services/apiEndpoint.types.ts';
import { useGetIdentity, useUrlParamValue } from 'src/hooks';
import { createIdea, editIdea } from 'src/store/ideaHub/ideaHub.slice';
import { assignModalId } from 'src/store/common/common.slice';
import JsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import MarkdownIt from 'markdown-it';
import Htraction from 'src/assets/images/logo/htraction.png';
import Ideahub from 'src/assets/images/logo/ideahub.png';
import Header from 'src/assets/images/logo/header.png';

// import { IdeaEvaluationDetails } from './ideaEvaluationDetails/IdeaEvaluationDetails';
import useAllowedActions from './ideaDetailsActions/useAllowedActions';
import './ideaDetails.scss';

import {
  TIdeaDetailsSections,
  TIdeaStatus,
  TIdeaCollaborationType,
  TIdeaViewType,
  TGetIdea,
  TEvaluatorResponse,
  TIdea,
  TIdeaCollaborator,
  TIdeaMarketDetailsData,
  TIdeaProblemsSolutionsData,
  TIdeaBusinessModelCompetitorsData,
  TIdeaValidationReport,
  TIdeaSharedFor
} from '../ideaHub.types';
import { IdeaViewTypeContext } from '../ideaSkeleton/IdeaSkeleton';

import { StorageUtils } from 'src/utils';

import {
  IdeaEvaluationDetails,
  Details,
  EditBusinessModelCompetitors,
  EditDetails,
  EditMarketDetails,
  EditProblemsSolutions,
  IdeaDetailsActions,
  IdeaDetailsSectionView,
  ViewRatings
} from '.';
import { set } from 'lodash';
import { json } from 'stream/consumers';

export type TIdeaDetailsProps = {
  ideaStatus: TIdeaStatus;
  ideaCollaborationType: TIdeaCollaborationType;
  ideaData: TGetIdea;
  ratings: TEvaluatorResponse[];
  ideaSharedFor?: TIdeaSharedFor;
  ideaRatedByUser?: boolean;
};

export type TEditIdeaFormValues = {
  title?: string;
  domain?: string;
  // description?: string;
  // marketSize?: string;
  targetAudience?: string;
  // marketTrends?: string;
  identifiedProblem?: string;
  solutionEffectiveness?: string;
  uniqueValueProposition?: string;
  majorRevenueStream?: string;
  // scaliblityOfIdea?: string;
  competitors?: string;
  // keyDifferentiatingFactor?: string;
};

const IdeaDetails = ({
  ideaStatus,
  ideaCollaborationType,
  ideaData,
  ratings,
  ideaSharedFor,
  ideaRatedByUser
}: TIdeaDetailsProps) => {
  // Hooks
  const { getIdentities } = useGetIdentity();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { paramValue } = useUrlParamValue();

  const isAuthorized: boolean = useAppSelector<boolean>((store: any) => store.auth.isAuthorized);

  const { loggedInUserId } = getIdentities();
  const editIdeaType: 'newIdea' | 'draft' = paramValue({ paramName: 'editType' }) as
    | 'newIdea'
    | 'draft';
  const editIdeaId: string = paramValue({ paramName: 'id' }) as unknown as string;

  const { idea, collaborators }: { idea: TIdea; collaborators: TIdeaCollaborator[] } = ideaData;

  // localdata
  const ideaExistData: string | null = StorageUtils.get('ideahubdetails')

  const {
    title,
    domain,
    // description,
    owner,
    // marketSize,
    targetAudience,
    // marketTrends,
    identifiedProblem,
    solutionEffectiveness,
    uniqueValueProposition,
    majorRevenueStream,
    // scaliblityOfIdea,
    competitors,
    validationReport
    // keyDifferentiatingFactor
  } = idea;

  const [currentIdeaDetailsIndex, setCurrentIdeaDetailsIndex] = useState<number>(0);
  const [editIdeaFormValues, setEditIdeaFormValues] = useState<TEditIdeaFormValues>({
    title,
    domain,
    // description,
    // marketSize,
    targetAudience,
    // marketTrends,
    identifiedProblem,
    solutionEffectiveness,
    uniqueValueProposition,
    majorRevenueStream,
    // scaliblityOfIdea,
    competitors
    // keyDifferentiatingFactor
  });
  const submitButtonRef = useRef<FormikProps<TEditIdeaFormValues>>(null);

  const [show, setShow] = useState<boolean>(false)

  const ideaSteps: TIdeaDetailsSections[] = [
    'details',
    'ideaEvaluation',
    'ideaRating'
  ];

  const marketDetails: TIdeaMarketDetailsData = {
    // marketSize,
    targetAudience
    // marketTrends
  };
  const ideaProblemsSolutions: TIdeaProblemsSolutionsData = {
    identifiedProblem,
    solutionEffectiveness,
    uniqueValueProposition
  };
  const ideaBusinessModelCompetitors: TIdeaBusinessModelCompetitorsData = {
    majorRevenueStream,
    // scaliblityOfIdea,
    competitors,
    targetAudience
    // keyDifferentiatingFactor
  };
  const ideaValidationReport: TIdeaValidationReport = {
    validationReport
  };

  const ideaViewContext: TIdeaViewType = useContext(IdeaViewTypeContext);

  const updateFormValues = ({ values }: { values: TEditIdeaFormValues }) => {
    setEditIdeaFormValues((prev) => ({ ...prev, ...values }));
  };

  const goToNextTab = ({ fromEditDetails }: { fromEditDetails: boolean }) => {
    setCurrentIdeaDetailsIndex((prev) => {
      if (prev === 0 && !fromEditDetails) {
        handleNext();
        return prev;
      } else if (ideaSteps[prev + 1]) {
        return prev + 1;
      }
      return prev;
    });
  };

  const handleNext = () => {
    if (submitButtonRef.current) {
      submitButtonRef.current.handleSubmit();
    }
  };

  const { checkButtonsVisibility } = useAllowedActions({
    ideaStatus,
    ideaCollaborationType,
    currentIdeaDetailsSection: ideaSteps[currentIdeaDetailsIndex],
    ideaSharedFor,
    viewType: ideaViewContext
  });

  const {
    showEditButton,
    showFinalizeButton,
    showValidateButton,
    showShareManageAccessButtons,
    showNextButton,
    showDiscardIdeaButton,
    showSaveButton,
    showRateIdeaButton
  } = checkButtonsVisibility();

  // This button is present in Idea hub -> Idea -> Idea details -> Edit details
  const { showShareManageAccessButtonsEditDetails } = checkButtonsVisibility();

  const handleDiscard = () => {
    if (submitButtonRef.current) {
      submitButtonRef.current.handleReset();
    }
    setEditIdeaFormValues({
      title: '',
      domain: '',
      // description: '',
      // marketSize: '',
      targetAudience: '',
      // marketTrends: '',
      identifiedProblem: '',
      solutionEffectiveness: '',
      uniqueValueProposition: '',
      majorRevenueStream: '',
      // scaliblityOfIdea: '',
      competitors: ''
      // keyDifferentiatingFactor: ''
    });
    if (editIdeaType === 'newIdea') {
      navigate('/view-empty-idea?tab=ideaDetails');
      dispatch(assignModalId(''));
    } else {
      const payload: TEditIdeaRequest = {
        ideaId: editIdeaId,
        status: 'Discard',
        title: 'Title that best reflects your idea',
        domain: 'Select a specific domain your idea relates to',
        // description: 'Elaborate on your idea with details.',
        // marketSize: 'Describe size of the market for your idea.',
        targetAudience: 'Describe the specific demographic or group your idea.',
        // marketTrends: 'Outline current and emerging trends relevant to your idea',
        identifiedProblem: 'Clearly state and elaborate on the problem your idea aims to address',
        solutionEffectiveness:
          'Explain how effective your proposed solution is in addressing the identified problem.',
        uniqueValueProposition: 'Describe the distinctive value your idea offers',
        majorRevenueStream:
          'Specify the primary source through which your business generates revenue',
        // scaliblityOfIdea: 'Describe the potential for your idea to grow and expand',
        competitors: 'List and analyze the key competitors in your idea.',
        // keyDifferentiatingFactor:
        // 'Highlight the unique feature or aspect that sets your idea apart from competitors.',
        discardIdea: true,
        userId: loggedInUserId
      };

      dispatch(editIdea(payload)).then(() => {
        navigate(`/view-idea?id=${editIdeaId}&tab=ideaDetails`);
      });
    }
  };

  const [validationErrors, setValidationErrors] = useState({
    title: false,
    domain: false
  });
  const handleSave = () => {
    if (!isAuthorized) {
      setShow(true)
      return
    }
    const {
      title,
      domain,
      // description,
      // marketSize,
      targetAudience,
      // marketTrends,
      identifiedProblem,
      solutionEffectiveness,
      uniqueValueProposition,
      majorRevenueStream,
      // scaliblityOfIdea,
      competitors
      // keyDifferentiatingFactor
    } = editIdeaFormValues;

    let hasError = {
      title: false,
      domain: false
    }
    if (title === 'Title that best reflects your idea' || title === '' || domain === 'Select a specific domain your idea relates to') {
      hasError = {
        title: title === 'Title that best reflects your idea' || title === '',
        domain: domain === 'Select a specific domain your idea relates to'
      }
      return
    }

    if (domain === '' || domain === 'Select a specific domain your idea relates to') {
      return
    }

    if (title.length > 76) {
      hasError.title = true
      return
    }

    setValidationErrors(hasError)

    if (editIdeaType === 'newIdea') {
      const payload: TCreateIdeaRequest = {
        ownerId: loggedInUserId,
        title: title || 'Title that best reflects your idea',
        domain: domain || 'Select a specific domain your idea relates to',
        // description: description || 'Elaborate on your idea with details.',
        // marketSize: marketSize || 'Describe size of the market for your idea.',
        targetAudience: targetAudience || 'Describe the specific demographic or group your idea.',
        // marketTrends: marketTrends || 'Outline current and emerging trends relevant to your idea',
        identifiedProblem:
          identifiedProblem ||
          'Clearly state and elaborate on the problem your idea aims to address',
        solutionEffectiveness:
          solutionEffectiveness ||
          'Explain how effective your proposed solution is in addressing the identified problem.',
        uniqueValueProposition:
          uniqueValueProposition || 'Describe the distinctive value your idea offers',
        majorRevenueStream:
          majorRevenueStream ||
          'Specify the primary source through which your business generates revenue',
        // scaliblityOfIdea:
        // scaliblityOfIdea || 'Describe the potential for your idea to grow and expand',
        competitors: competitors || 'List and analyze the key competitors in your idea.'
        // keyDifferentiatingFactor:
        //   keyDifferentiatingFactor ||
        //   'Highlight the unique feature or aspect that sets your idea apart from competitors.'
      };

      dispatch(createIdea(payload));
    } else if (editIdeaId && editIdeaType === 'draft') {
      const payload: TEditIdeaRequest = {
        ideaId: editIdeaId,
        status: ideaStatus,
        userId: loggedInUserId,
        title: title || 'Title that best reflects your idea',
        domain: domain || 'Select a specific domain your idea relates to',
        // description: description || 'Elaborate on your idea with details.',
        ...(domain && { domain }),
        // ...(description && { description }),
        // ...(marketSize && { marketSize }),
        ...(targetAudience && { targetAudience }),
        // ...(marketTrends && { marketTrends }),
        ...(identifiedProblem && { identifiedProblem }),
        ...(solutionEffectiveness && { solutionEffectiveness }),
        ...(uniqueValueProposition && { uniqueValueProposition }),
        ...(majorRevenueStream && { majorRevenueStream }),
        // ...(scaliblityOfIdea && { scaliblityOfIdea }),
        ...(competitors && { competitors })
        // ...(keyDifferentiatingFactor && { keyDifferentiatingFactor })
      };

      dispatch(editIdea(payload));
    }
  };
  // const openFinalizeIdeaModal = () => {
  //   dispatch(assignModalId(confirmFinalizeIdeaModalId));
  // };
  const confirmFinalizeIdeaModalId = 'confirmFinalizeIdeaModal';
  const confirmValidateIdeaModalId = 'confirmValidateIdeaModal';
  const openFinalizeIdeaModal = () => {
    dispatch(assignModalId(confirmFinalizeIdeaModalId));
  };
  const openValidateIdeaModal = () => {
    dispatch(assignModalId(confirmValidateIdeaModalId));
  };

  function handleNavigate() {
    navigate('/login?prev=' + encodeURIComponent('/edit-idea?tab=ideaDetails&editType=newIdea'));
  }

  interface TextOptions {
    fontSize?: number;
    fontStyle?: 'normal' | 'italic' | 'bold' | 'bolditalic';
    fontWeight?: 'normal' | 'bold';
    color?: [number, number, number];
    align?: 'left' | 'center' | 'right' | 'justify';
    indent?: number;
  }
  // pdf report generation functions
  async function convertToMarkdown(data) {
    const markdownSections = {
      overallFeedback: "### 1. Overall Feedback",
      marketFeasibility: "### 2. Market Feasibility",
      idealCustomerAndProfile: "### 3. Ideal Customer and Profile",
      competitiveAnalysis: "### 4. Competitive Analysis",
      marketSizeAndGrowthPotential: "### 5. Market Size and Growth Potential",
      goToMarketStrategy: "### 6. Go-To-Market Strategy",
      risksAndMitigationStrategies: "### 7. Risks and Mitigation Strategies",
      financialViability: "### 8. Financial Viability",
      oneHighValueRecommendation: "### 9. One High-Value Recommendation"
    };

    const sanitizeMarkdown = (text) => {
      return text
        // First fix the colon-dash pattern with line breaks
        .replace(/:\s*\n\s*-\s*/g, ': - ')
        // Then fix colons followed by line breaks (not dashes)
        .replace(/:\s*\n(?!\s*-)/g, ': ')
        // Fix dashes preceded by line breaks (not colons)
        .replace(/(?<!:\s*)\n\s*-\s*/g, ' - ')
        // Remove any remaining line breaks after colons
        .replace(/:\s*\n/g, ': ')
        // Remove any remaining line breaks after dashes
        .replace(/-\s*\n/g, ' - ')
        // Normalize multiple spaces
        .replace(/[ ]{2,}/g, ' ')
        // Normalize line breaks
        .replace(/\n{3,}/g, '\n\n')
        .trim();
    };

    let markdown = "";
    for (const [key, title] of Object.entries(markdownSections)) {
      if (data[key]) {
        markdown += `${title}\n\n${sanitizeMarkdown(data[key])}\n\n`;
      }
    }

    return markdown.trim();
  }

  const exportReportToPDF = async (report) => {
    // Create loading spinner
    const loader = document.createElement('div');
    loader.id = 'pdfLoader';
    Object.assign(loader.style, {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: '1000'
    });
    loader.innerHTML = `...`; // Keep your existing loader HTML
    document.body.appendChild(loader);

    try {
      async function parseJsonString(input) {
        try {
          const parsed = JSON.parse(input);
          return parsed;
        } catch (error) {
          console.error("Failed to parse JSON string:", error);
          return null;
        }
      }

      // Usage
      const a = "{\"overallFeedback\":\"**Overall Evaluation**: Your cybersecurity startup idea is well-positioned...<truncated for brevity>...\"}";
      // const parsedJson = await parseJsonString(report.validationReport);
      //     const jsonToMarkdownReport = await convertToMarkdown(parsedJson);
      //     console.log('Converted Markdown Report:', jsonToMarkdownReport);

      // const parseJsonString = async (input) => {
      //   try {
      //     return JSON.parse(input);
      //   } catch (error) {
      //     console.error("Failed to parse JSON string:", error);
      //     return null;
      //   }
      // };

      const cleanReportText = (report) => {
        for (const key in report) {
          if (typeof report[key] === 'string') {
            report[key] = report[key]
              .replace(/:\s*\n/g, ': ')
              .replace(/\n{3,}/g, '\n\n')
              .replace(/[ ]{2,}/g, ' ');
          }
        }
        return report;
      };

      const parsedJson = await parseJsonString(report.validationReport);
      if (!parsedJson) throw new Error("Invalid JSON report data");

      cleanReportText(parsedJson);
      const jsonToMarkdownReport = await convertToMarkdown(parsedJson);
      const sanitizeField = (val) => {
        if (!val) return '';

        return val.trim()
          .replace(/:\s*-\s*\n/g, ': - ')
          .replace(/:\s*\n(?!\s*-)/g, ': ')
          .replace(/(?<!:\s*)-\s*\n/g, ' - ')
          .replace(/\n(?=\s*[-•*]\s)/g, ' ')
          .replace(/\n(?=\s*[:-])/g, ' ')
          .replace(/\n(?=\s*[a-zA-Z0-9])/g, ' ')
          .replace(/:\s+-\s+/g, ': - ')
          .replace(/\n{3,}/g, '\n\n')
          .replace(/[ ]{2,}/g, ' ')
          .trim();
      };
      const ideaDetails = `### Idea details
**Title:** ${sanitizeField(idea.title)}  
**Domain:** ${sanitizeField(idea.domain)}  
**Identified Problem:** ${sanitizeField(idea.identifiedProblem)}  
**Solution Effectiveness:** ${sanitizeField(idea.solutionEffectiveness)}  
**Unique Value Proposition:** ${sanitizeField(idea.uniqueValueProposition)}  
**Major Revenue Stream:** ${sanitizeField(idea.majorRevenueStream)}  
**Competitors:** ${sanitizeField(idea.competitors)}  
**Target Audience:** ${sanitizeField(idea.targetAudience)}
`;

      const markdownContent = `${ideaDetails}\n---\n${jsonToMarkdownReport}`
        .replace(/\n{3,}/g, '\n\n')
        .replace(/[ ]{2,}/g, ' ')
        .trim();
      const doc = new JsPDF();
      const mdParser = new MarkdownIt();

      // Page dimensions and constants
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const marginTop = 30; // Increased top margin to leave space for header
      const marginBottom = 30; // Increased bottom margin to leave space for footer
      const marginLeft = 20;
      const marginRight = 20;
      const lineHeight = 7;
      let yPos = marginTop;

      // Check if we need a new page before adding content
      const checkPageBreak = (requiredHeight = lineHeight): void => {
        if (yPos + requiredHeight > pageHeight - marginBottom) {
          addFooter();
          doc.addPage();
          yPos = marginTop; // Reset Y position after page break
          addHeader();
        }
      };

      // const addFormattedText = (text: string, options: TextOptions = {}): void => {
      //   const { fontSize = 12, fontStyle = 'normal', fontWeight = 'normal', color = [0, 0, 0], align = 'left', indent = 0 } = options;
      //   doc.setFontSize(fontSize);

      //   // Apply correct font style and weight
      //   if (fontWeight === 'bold' && fontStyle === 'italic') {
      //     doc.setFont('helvetica', 'bolditalic');
      //   } else if (fontWeight === 'bold') {
      //     doc.setFont('helvetica', 'bold');
      //   } else if (fontStyle === 'italic') {
      //     doc.setFont('helvetica', 'italic');
      //   } else {
      //     doc.setFont('helvetica', 'normal');
      //   }

      //   doc.setTextColor(...color);
      //   const maxWidth = pageWidth - marginLeft - marginRight - indent;
      //   const lines = doc.splitTextToSize(text, maxWidth);

      //   lines.forEach((line) => {
      //     checkPageBreak(); // Check before each line
      //     doc.text(line, marginLeft + indent, yPos, { align });
      //     yPos += lineHeight;
      //   });
      // };

      // Add this interface at the top of your file or in a types file
      interface TextOptions {
        fontSize?: number;
        fontStyle?: 'normal' | 'italic';
        fontWeight?: 'normal' | 'bold';
        color?: [number, number, number];
        align?: 'left' | 'center' | 'right';
        indent?: number;
      }

      // Updated addFormattedText function with proper TypeScript types
      const addFormattedText = (text: string, options: TextOptions = {}): void => {
        const { fontSize = 12, fontStyle = 'normal', fontWeight = 'normal', color = [0, 0, 0], align = 'left', indent = 0 } = options;
        doc.setFontSize(fontSize);

        // Apply correct font style and weight
        if (fontWeight === 'bold' && fontStyle === 'italic') {
          doc.setFont('helvetica', 'bolditalic');
        } else if (fontWeight === 'bold') {
          doc.setFont('helvetica', 'bold');
        } else if (fontStyle === 'italic') {
          doc.setFont('helvetica', 'italic');
        } else {
          doc.setFont('helvetica', 'normal');
        }

        doc.setTextColor(color[0], color[1], color[2]);
        const maxWidth = pageWidth - marginLeft - marginRight - indent;

        // Custom text splitting that keeps colons and dashes with their preceding words
        const smartSplitText = (text: string, maxWidth: number): string[] => {
          const words = text.split(' ');
          const lines: string[] = [];
          let currentLine = '';

          for (let i = 0; i < words.length; i++) {
            const word = words[i];
            const testLine = currentLine + (currentLine ? ' ' : '') + word;
            const testWidth = doc.getStringUnitWidth(testLine) * fontSize / 72 * 25.4;

            if (testWidth <= maxWidth) {
              currentLine = testLine;
            } else {
              // Before starting a new line, check if current word ends with : or : -
              if (currentLine && (word.match(/^[:-]/) || word.match(/^-/))) {
                // If the word starts with : or -, try to keep it with the previous word
                const lastSpaceIndex = currentLine.lastIndexOf(' ');
                if (lastSpaceIndex !== -1) {
                  const lastWord = currentLine.substring(lastSpaceIndex + 1);
                  const remainingLine = currentLine.substring(0, lastSpaceIndex);
                  const combinedWord = lastWord + ' ' + word;
                  const combinedWidth = doc.getStringUnitWidth(combinedWord) * fontSize / 72 * 25.4;

                  // If the combined word fits on the next line, move both
                  if (combinedWidth <= maxWidth) {
                    if (remainingLine) {
                      lines.push(remainingLine);
                    }
                    currentLine = combinedWord;
                    continue;
                  }
                }
              }

              // Check if current word contains : or : - pattern
              if (word.includes(':')) {
                // Split the word at colon but keep colon with preceding part
                const colonIndex = word.indexOf(':');
                const beforeColon = word.substring(0, colonIndex + 1);
                const afterColon = word.substring(colonIndex + 1);

                const testWithColon = currentLine + (currentLine ? ' ' : '') + beforeColon;
                const testColonWidth = doc.getStringUnitWidth(testWithColon) * fontSize / 72 * 25.4;

                if (testColonWidth <= maxWidth) {
                  currentLine = testWithColon;
                  if (afterColon) {
                    // Add the part after colon to next iteration
                    words.splice(i + 1, 0, afterColon);
                  }
                  continue;
                }
              }

              // Standard behavior: push current line and start new one
              if (currentLine) {
                lines.push(currentLine);
              }
              currentLine = word;
            }
          }

          if (currentLine) {
            lines.push(currentLine);
          }

          return lines;
        };

        const lines = smartSplitText(text, maxWidth);

        lines.forEach((line) => {
          checkPageBreak(); // Check before each line
          doc.text(line, marginLeft + indent, yPos, { align });
          yPos += lineHeight;
        });
      };

      const addFooter = (): void => {
        const footerY = pageHeight - marginBottom / 2;
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);
        doc.textWithLink('www.htraction.com', pageWidth / 2, footerY, {
          align: 'center',
          url: 'https://www.htraction.com'
        });
      };

      const addHeader = (): void => {
        const logoWidth = 11;
        const logoHeight = 11;
        // Place the header at the top of the page with proper margins
        doc.addImage(Header, 'PNG', pageWidth - marginRight - logoWidth, marginTop / 2, logoWidth, logoHeight);
        // Reset font styles after adding header
        doc.setFontSize(12);
        doc.setFont('helvetica', 'normal');
      };

      const createCoverPage = (): void => {
        addHeader();
        // Start content after header with appropriate spacing
        yPos = marginTop + 20;

        doc.setFillColor(250, 70, 22);
        doc.rect(marginLeft, yPos, pageWidth - marginLeft - marginRight, 15, 'F');
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(14);
        doc.setTextColor(255, 255, 255);
        doc.text('Idea Validation Report', pageWidth / 2, yPos + 12, { align: 'center' });

        yPos += 30; // Move down for next element

        // Handle idea title with potential wrapping
        doc.setFillColor(250, 70, 22);
        const titleText = `Idea Title - ${idea.title}`;
        doc.setFontSize(12);

        // Calculate how much space the text will need
        const titleWidth = pageWidth - marginLeft - marginRight - 20; // Adding some padding
        const titleSplitText = doc.splitTextToSize(titleText, titleWidth);
        const titleHeight = titleSplitText.length * 7; // Approximately 7 points per line

        // Create rectangle that can expand based on text height
        doc.rect(marginLeft, yPos, pageWidth - marginLeft - marginRight, titleHeight + 6, 'F');

        // Center the text vertically inside the rectangle
        doc.setTextColor(255, 255, 255);
        const textYPos = yPos + 6; // Initial position
        for (let i = 0; i < titleSplitText.length; i++) {
          doc.text(titleSplitText[i], pageWidth / 2, textYPos + (i * 7), { align: 'center' });
        }

        yPos += titleHeight + 16; // Move down past the title rectangle with some extra space

        // Continue with logos
        const image1Width = 70;
        const image1Height = 20;
        const image2Width = 38;
        const image2Height = 20;
        doc.addImage(Htraction, 'PNG', marginLeft + 20, yPos, image1Width, image1Height);
        doc.addImage(Ideahub, 'PNG', marginLeft + 105, yPos, image2Width, image2Height);

        yPos += 40; // Move down for taglines
        doc.setFontSize(14);
        doc.setTextColor(0, 0, 0);
        doc.text('The world needs entrepreneurs', pageWidth / 2, yPos, { align: 'center' });
        yPos += 10;
        doc.text('Be one.', pageWidth / 2, yPos, { align: 'center' });

        addFooter();
      };

      const processMarkdownContent = (markdown: string): void => {
        const sections = markdown.split('---');
        sections.forEach((section, sectionIndex) => {
          if (sectionIndex > 0) {
            checkPageBreak(lineHeight * 2); // Check before adding section divider
            doc.setDrawColor(200, 200, 200);
            doc.line(marginLeft, yPos, pageWidth - marginRight, yPos);
            yPos += lineHeight * 2;
          }

          // Parse the entire section at once
          const tokens = mdParser.parse(section, {});

          // Recursively process tokens
          const processTokens = (tokens, startIndex = 0, endIndex = tokens.length, nestLevel = 0) => {
            for (let i = startIndex; i < endIndex; i++) {
              const token = tokens[i];

              if (token.type === 'heading_open') {
                // Process heading
                const level = parseInt(token.tag.substring(1), 10);
                const contentToken = tokens[i + 1];
                i += 2; // Skip the heading content and close tokens

                if (contentToken && contentToken.type === 'inline') {
                  checkPageBreak(lineHeight * 2); // Check before adding heading
                  addFormattedText(contentToken.content, {
                    fontSize: 16 + (3 - level) * 2,
                    fontWeight: 'bold'
                  });
                  // Reduced spacing after heading - removed the 0.5 lineHeight addition
                }
              } else if (token.type === 'paragraph_open') {
                // Process paragraph and its children
                const contentIndex = i + 1;
                let closeIndex = contentIndex;

                // Find the closing tag
                while (closeIndex < endIndex && tokens[closeIndex].type !== 'paragraph_close') {
                  closeIndex++;
                }

                // If we have inline content
                if (contentIndex < closeIndex && tokens[contentIndex].type === 'inline') {
                  const inlineToken = tokens[contentIndex];
                  let paragraphText = '';
                  const formatting = [];

                  // Process inline children (bold, italic, etc.)
                  if (inlineToken.children && inlineToken.children.length > 0) {
                    for (let j = 0; j < inlineToken.children.length; j++) {
                      const child = inlineToken.children[j];

                      if (child.type === 'text') {
                        paragraphText += child.content;
                      } else if (child.type === 'strong_open') {
                        const startPos = paragraphText.length;
                        // Find the content within strong tags
                        while (j + 1 < inlineToken.children.length && inlineToken.children[j + 1].type !== 'strong_close') {
                          j++;
                          if (inlineToken.children[j].type === 'text') {
                            paragraphText += inlineToken.children[j].content;
                          }
                        }
                        j++; // Skip the strong_close tag
                        formatting.push({
                          start: startPos,
                          end: paragraphText.length,
                          style: 'bold'
                        });
                      } else if (child.type === 'em_open') {
                        const startPos = paragraphText.length;
                        // Find the content within em tags
                        while (j + 1 < inlineToken.children.length && inlineToken.children[j + 1].type !== 'em_close') {
                          j++;
                          if (inlineToken.children[j].type === 'text') {
                            paragraphText += inlineToken.children[j].content;
                          }
                        }
                        j++; // Skip the em_close tag
                        formatting.push({
                          start: startPos,
                          end: paragraphText.length,
                          style: 'italic'
                        });
                      }
                    }
                  } else {
                    // Simple paragraph with no formatting
                    paragraphText = inlineToken.content;
                  }

                  // If there's no special formatting, add the text directly
                  if (formatting.length === 0) {
                    addFormattedText(paragraphText, { fontSize: 12 });
                  } else {
                    // Handle formatted text by breaking it into segments
                    let lastEnd = 0;
                    const sortedFormatting = formatting.sort((a, b) => a.start - b.start);

                    for (const format of sortedFormatting) {
                      // Add any unformatted text before this format
                      if (format.start > lastEnd) {
                        addFormattedText(paragraphText.substring(lastEnd, format.start), { fontSize: 12 });
                      }

                      // Add the formatted text
                      const options: TextOptions = { fontSize: 12 };
                      if (format.style === 'bold') {
                        options.fontWeight = 'bold';
                      } else if (format.style === 'italic') {
                        options.fontStyle = 'italic';
                      }

                      addFormattedText(paragraphText.substring(format.start, format.end), options);
                      lastEnd = format.end;
                    }

                    // Add any remaining unformatted text
                    if (lastEnd < paragraphText.length) {
                      addFormattedText(paragraphText.substring(lastEnd), { fontSize: 12 });
                    }
                  }

                  // Add slightly less space after paragraphs
                  yPos += lineHeight * 0.3;
                }

                // Skip to after paragraph close
                i = closeIndex;
              } else if (token.type === 'bullet_list_open') {
                // Process bullet list
                let listIndex = i + 1;

                while (listIndex < endIndex && tokens[listIndex].type !== 'bullet_list_close') {
                  if (tokens[listIndex].type === 'list_item_open') {
                    // Find the content within this list item
                    let contentIdx = listIndex + 1;
                    while (contentIdx < endIndex &&
                      tokens[contentIdx].type !== 'paragraph_open' &&
                      tokens[contentIdx].type !== 'inline') {
                      contentIdx++;
                    }

                    // If we found content
                    if (contentIdx < endIndex) {
                      if (tokens[contentIdx].type === 'paragraph_open') {
                        // Skip to inline content
                        contentIdx++;
                      }

                      if (contentIdx < endIndex && tokens[contentIdx].type === 'inline') {
                        const inlineToken = tokens[contentIdx];

                        // Combine all text and formatting into a single string
                        let combinedContent = '';
                        const formattingRanges = [];

                        // Process inline children to build combined content
                        if (inlineToken.children && inlineToken.children.length > 0) {
                          for (let j = 0; j < inlineToken.children.length; j++) {
                            const child = inlineToken.children[j];

                            if (child.type === 'text') {
                              combinedContent += child.content;
                            } else if (child.type === 'strong_open') {
                              const startPos = combinedContent.length;
                              let boldContent = '';

                              // Find the content within strong tags
                              while (j + 1 < inlineToken.children.length && inlineToken.children[j + 1].type !== 'strong_close') {
                                j++;
                                if (inlineToken.children[j].type === 'text') {
                                  boldContent += inlineToken.children[j].content;
                                }
                              }

                              combinedContent += boldContent;
                              j++; // Skip the strong_close

                              formattingRanges.push({
                                start: startPos,
                                end: combinedContent.length,
                                style: 'bold'
                              });
                            } else if (child.type === 'em_open') {
                              const startPos = combinedContent.length;
                              let italicContent = '';

                              // Find the content within em tags
                              while (j + 1 < inlineToken.children.length && inlineToken.children[j + 1].type !== 'em_close') {
                                j++;
                                if (inlineToken.children[j].type === 'text') {
                                  italicContent += inlineToken.children[j].content;
                                }
                              }

                              combinedContent += italicContent;
                              j++; // Skip the em_close

                              formattingRanges.push({
                                start: startPos,
                                end: combinedContent.length,
                                style: 'italic'
                              });
                            }
                          }
                        } else {
                          // Simple text with no formatting
                          combinedContent = inlineToken.content;
                        }

                        // Check if we have space for at least one line of the bullet
                        checkPageBreak();

                        // Add bullet at current position
                        const bulletStartY = yPos;
                        doc.setFont('helvetica', 'normal');
                        doc.setFontSize(12);
                        doc.text('• ', marginLeft + 10, yPos);

                        // Prepare the content
                        const indentation = 10;
                        const bulletWidth = doc.getStringUnitWidth('• ') * 12 / 72 * 25.4;
                        const textStartX = marginLeft + 10 + bulletWidth;
                        const availableWidth = pageWidth - marginRight - textStartX;

                        // If no special formatting, use the text wrapping function
                        if (formattingRanges.length === 0) {
                          // Split text to fit within available width
                          const lines = doc.splitTextToSize(combinedContent, availableWidth);

                          // First line goes next to bullet
                          if (lines.length > 0) {
                            checkPageBreak();
                            doc.text(lines[0], textStartX, bulletStartY);
                          }

                          // Subsequent lines go below with indentation
                          for (let lineIdx = 1; lineIdx < lines.length; lineIdx++) {
                            checkPageBreak();
                            yPos += lineHeight;
                            doc.text(lines[lineIdx], textStartX, yPos);
                          }
                        } else {
                          // For formatted text, we need to handle it segment by segment
                          // Sort formatting ranges
                          const sortedRanges = formattingRanges.sort((a, b) => a.start - b.start);

                          // Current position tracking
                          let lineStartY = bulletStartY;
                          let currentX = textStartX;
                          let lastEnd = 0;

                          // Process each segment
                          for (let rangeIdx = 0; rangeIdx <= sortedRanges.length; rangeIdx++) {
                            let segment;
                            let segmentStyle = 'normal';

                            if (rangeIdx < sortedRanges.length) {
                              const range = sortedRanges[rangeIdx];

                              // Add any text before this range
                              if (range.start > lastEnd) {
                                segment = combinedContent.substring(lastEnd, range.start);
                                segmentStyle = 'normal';
                              } else {
                                segment = combinedContent.substring(range.start, range.end);
                                segmentStyle = range.style;
                              }

                              lastEnd = range.end;
                            } else if (lastEnd < combinedContent.length) {
                              // Add any remaining text after all ranges
                              segment = combinedContent.substring(lastEnd);
                              segmentStyle = 'normal';
                            } else {
                              break; // No more text to process
                            }

                            if (!segment || segment.length === 0) continue;

                            // Set appropriate font style
                            if (segmentStyle === 'bold') {
                              doc.setFont('helvetica', 'bold');
                            } else if (segmentStyle === 'italic') {
                              doc.setFont('helvetica', 'italic');
                            } else {
                              doc.setFont('helvetica', 'normal');
                            }

                            // Split segment to fit available width
                            const segmentWidth = doc.getStringUnitWidth(segment) * 12 / 72 * 25.4;

                            // Check if the segment fits on the current line
                            if (currentX + segmentWidth > pageWidth - marginRight) {
                              // Start a new line with proper indentation
                              checkPageBreak();
                              yPos += lineHeight;
                              lineStartY = yPos;
                              currentX = textStartX;
                            }

                            // Measure each word to handle wrapping within segments
                            const words = segment.split(' ');
                            let currentWordIndex = 0;

                            while (currentWordIndex < words.length) {
                              const currentLineWords = [];
                              let lineWidth = 0;

                              // Build up a line of text that fits within available width
                              while (currentWordIndex < words.length) {
                                const word = words[currentWordIndex];
                                const wordWidth = doc.getStringUnitWidth(word + ' ') * 12 / 72 * 25.4;

                                if (currentX + lineWidth + wordWidth <= pageWidth - marginRight) {
                                  currentLineWords.push(word);
                                  lineWidth += wordWidth;
                                  currentWordIndex++;
                                } else {
                                  break; // Line is full
                                }
                              }

                              // If we have words for this line, render them
                              if (currentLineWords.length > 0) {
                                const lineText = currentLineWords.join(' ');
                                doc.text(lineText, currentX, lineStartY);

                                // Update position for next segment
                                currentX += doc.getStringUnitWidth(lineText + ' ') * 12 / 72 * 25.4;

                                // If there are more words, start a new line
                                if (currentWordIndex < words.length) {
                                  checkPageBreak();
                                  yPos += lineHeight;
                                  lineStartY = yPos;
                                  currentX = textStartX;
                                }
                              } else {
                                // This handles the case where a single word is too long for the line
                                // We have to split it character by character
                                const word = words[currentWordIndex];
                                let charIndex = 0;
                                let currentChars = '';

                                while (charIndex < word.length) {
                                  const nextChar = word[charIndex];
                                  const charWidth = doc.getStringUnitWidth(nextChar) * 12 / 72 * 25.4;

                                  if (currentX + doc.getStringUnitWidth(currentChars + nextChar) * 12 / 72 * 25.4 <= pageWidth - marginRight) {
                                    currentChars += nextChar;
                                    charIndex++;
                                  } else {
                                    // Render current chars and move to next line
                                    if (currentChars.length > 0) {
                                      doc.text(currentChars, currentX, lineStartY);
                                    }

                                    checkPageBreak();
                                    yPos += lineHeight;
                                    lineStartY = yPos;
                                    currentX = textStartX;
                                    currentChars = '';
                                  }
                                }

                                // Render any remaining chars
                                if (currentChars.length > 0) {
                                  doc.text(currentChars, currentX, lineStartY);
                                  currentX += doc.getStringUnitWidth(currentChars + ' ') * 12 / 72 * 25.4;
                                }

                                currentWordIndex++;
                              }
                            }
                          }
                        }

                        // Move to next line after bullet point is complete
                        yPos += lineHeight;
                      }
                    }
                  }

                  // Move to the next token
                  listIndex++;
                }

                // Skip to after bullet_list_close
                i = listIndex;
                yPos += lineHeight * 0.5;
              } else if (token.type === 'hr') {
                // Horizontal rule
                checkPageBreak();
                doc.setDrawColor(200, 200, 200);
                doc.line(marginLeft, yPos, pageWidth - marginRight, yPos);
                yPos += lineHeight;
              }
            }
          };

          // Process the entire section
          processTokens(tokens);
        });
      };

      createCoverPage();
      doc.addPage();
      yPos = marginTop; // Set Y position to start after header
      addHeader();
      //     const markdownContent = `### Idea details
      // **Title:** ${idea.title.trim()}  
      // **Domain:** ${idea.domain.trim()}  
      // **Identified Problem:** ${idea.identifiedProblem.trim()}  
      // **Solution Effectiveness:** ${idea.solutionEffectiveness.trim()}  
      // **Unique Value Proposition:** ${idea.uniqueValueProposition.trim()}  
      // **Major Revenue Stream:** ${idea.majorRevenueStream.trim()}  
      // **Competitors:** ${idea.competitors.trim()}  
      // **Target Audience:** ${idea.targetAudience.trim()}
      // ---
      // ${jsonToMarkdownReport}`;
      processMarkdownContent(markdownContent);
      addFooter();
      doc.save(`Validation Report - ${idea.title}.pdf`);
    } catch (error) {
      console.error('Error generating PDF:', error);
    } finally {
      document.body.removeChild(loader);
    }
  };

  const ideaDetailsSections: { key: TIdeaDetailsSections; label: string; component: ReactNode }[] =
    [
      {
        key: 'details',
        label: 'Details',
        component:
          ideaViewContext === 'editIdea' ? (
            <div className='scrollable-container'>
              <EditDetails
                title={editIdeaFormValues?.title}
                domain={editIdeaFormValues?.domain}
                // description={editIdeaFormValues?.description}
                owner={idea?.owner}
                collaborators={collaborators}
                submitButtonRef={submitButtonRef}
                updateFormValues={updateFormValues}
                validationErrors={validationErrors}
                handleNext={handleNext}
                goToNextTab={goToNextTab}
                showShareManageAccessButtonsEditDetails={showShareManageAccessButtonsEditDetails}
              />
              {/* <EditMarketDetails
              // marketSize={editIdeaFormValues.marketSize}
              targetAudience={editIdeaFormValues.targetAudience}
              // marketTrends={editIdeaFormValues.marketTrends}
              submitButtonRef={submitButtonRef}
              updateFormValues={updateFormValues}
              handleNext={handleNext}
              goToNextTab={goToNextTab}
            /> */}
              <EditProblemsSolutions
                identifiedProblem={editIdeaFormValues.identifiedProblem}
                solutionEffectiveness={editIdeaFormValues.solutionEffectiveness}
                uniqueValueProposition={editIdeaFormValues.uniqueValueProposition}
                submitButtonRef={submitButtonRef}
                updateFormValues={updateFormValues}
                handleNext={handleNext}
                goToNextTab={goToNextTab}
              />
              <EditBusinessModelCompetitors
                majorRevenueStream={editIdeaFormValues.majorRevenueStream}
                // scaliblityOfIdea={editIdeaFormValues.scaliblityOfIdea}
                competitors={editIdeaFormValues.competitors}
                // keyDifferentiatingFactor={editIdeaFormValues.keyDifferentiatingFactor}
                targetAudience={editIdeaFormValues.targetAudience}
                submitButtonRef={submitButtonRef}
                updateFormValues={updateFormValues}
              />
            </div>
          ) : (
            <div>
              <div className='scrollable-container'>
                <IdeaEvaluationDetails
                  title={title}
                  domain={domain}
                  // description={description}
                  owner={owner}
                  ideaSharedFor={ideaSharedFor}
                  collaborators={collaborators}
                  collaborationType={ideaCollaborationType}
                />
                {/* <IdeaDetailsSectionView sectionTitle="Market Details" data={marketDetails} /> */}
                <IdeaDetailsSectionView
                  sectionTitle="Problem & Solutions"
                  data={ideaProblemsSolutions}
                />
                <IdeaDetailsSectionView
                  sectionTitle="Business Model & Competitors"
                  data={ideaBusinessModelCompetitors}
                />
              </div>
              {showFinalizeButton && (<Button
                variant="primary"
                size="small"
                className="idea-details-actions__actions__finalize-idea"
                onClick={openFinalizeIdeaModal}
              >
                Finalize this idea
              </Button>)}
            </div>
          )
      }
      // {
      //   key: 'marketDetails',
      //   label: 'Market Details',
      //   component:
      //     ideaViewContext === 'editIdea' ? (
      //       <EditMarketDetails
      //         // marketSize={editIdeaFormValues.marketSize}
      //         targetAudience={editIdeaFormValues.targetAudience}
      //         // marketTrends={editIdeaFormValues.marketTrends}
      //         submitButtonRef={submitButtonRef}
      //         updateFormValues={updateFormValues}
      //         handleNext={handleNext}
      //         goToNextTab={goToNextTab}
      //       />
      //     ) : (
      //       <IdeaDetailsSectionView sectionTitle="Market Details" data={marketDetails} />
      //     )
      // },
      // {
      //   key: 'problemsSolutions',
      //   label: 'Problem & Solutions',
      //   component:
      //     ideaViewContext === 'editIdea' ? (
      //       <EditProblemsSolutions
      //         identifiedProblem={editIdeaFormValues.identifiedProblem}
      //         solutionEffectiveness={editIdeaFormValues.solutionEffectiveness}
      //         uniqueValueProposition={editIdeaFormValues.uniqueValueProposition}
      //         submitButtonRef={submitButtonRef}
      //         updateFormValues={updateFormValues}
      //         handleNext={handleNext}
      //         goToNextTab={goToNextTab}
      //       />
      //     ) : (
      //       <IdeaDetailsSectionView
      //         sectionTitle="Problem & Solutions"
      //         data={ideaProblemsSolutions}
      //       />
      //     )
      // },
      // {
      //   key: 'BusinessModelCompetitors',
      //   label: 'Business Model & Competitors',
      //   component:
      //     ideaViewContext === 'editIdea' ? (
      //       <EditBusinessModelCompetitors
      //         majorRevenueStream={editIdeaFormValues.majorRevenueStream}
      //         // scaliblityOfIdea={editIdeaFormValues.scaliblityOfIdea}
      //         competitors={editIdeaFormValues.competitors}
      //         // keyDifferentiatingFactor={editIdeaFormValues.keyDifferentiatingFactor}
      //         submitButtonRef={submitButtonRef}
      //         updateFormValues={updateFormValues}
      //       />
      //     ) : (
      //       <IdeaDetailsSectionView
      //         sectionTitle="Business Model & Competitors"
      //         data={ideaBusinessModelCompetitors}
      //       />
      //     )
      // }
    ];
  const isInAppropriate = idea?.validationReport?.includes('Please provide appropriate input to generate an actionable report.')
  const isJSONStructure = (content) => {
    if (!content) return false;

    if (typeof content === 'object' && content !== null) {
      return true;
    }

    if (typeof content === 'string') {
      try {
        const parsed = JSON.parse(content);
        // Check if it has the new structure keys
        return parsed && typeof parsed === 'object' &&
          (parsed.overallFeedback || parsed.marketFeasibility || parsed.idealCustomerAndProfile);
      } catch (e) {
        return false;
      }
    }

    return false;
  }
  const isJSON = isJSONStructure(idea?.validationReport);
  if (ideaViewContext !== 'editIdea') {
    if (ideaSharedFor !== 'Evaluation') {
      ideaDetailsSections.push({
        key: 'ideaEvaluation',
        label: 'Idea Validation',
        component: <div className="view-ideaEvaluation">
          <IdeaDetailsSectionView
            sectionTitle="Validation Report"
            data={ideaValidationReport}
          />
          {(idea.validationReport !== "No report generated!" && !isInAppropriate) &&
            <Button
              variant="primary"
              size="small"
              className="idea-details-actions__actions__finalize-idea"
              onClick={() => exportReportToPDF(ideaValidationReport)}
            >
              Export to pdf
            </Button>
          }
        </div>
      });
      ideaSteps.push('ideaEvaluation');
    }
    ideaDetailsSections.push({
      key: 'ideaRating',
      label: 'Idea Rating',
      component: <ViewRatings ratings={ratings} />
    });
    ideaSteps.push('ideaRating');
  }
  const currentIdeaDetailsComponent: ReactNode = useMemo(() => {
    try {
      const section = ideaDetailsSections[currentIdeaDetailsIndex];

      return section?.component;
    } catch {
      return <>-</>;
    }
  }, [currentIdeaDetailsIndex, JSON.stringify(ideaData), JSON.stringify(ratings), editIdeaFormValues]);
  const isValidated = useSelector((state: RootState) => state.validation.isValidated);
  useEffect(() => {
    if (isValidated && ideaViewContext !== 'editIdea') {
      // Find the index of the 'ideaEvaluation' section
      const ideaEvaluationIndex = ideaDetailsSections.findIndex(
        section => section.key === 'ideaEvaluation'
      );

      // If the section exists, set it as the current section
      if (ideaEvaluationIndex !== -1) {
        setCurrentIdeaDetailsIndex(ideaEvaluationIndex);
      }
    }
  }, [isValidated, ideaViewContext]);
  useEffect(() => {
    // Check if the current section is 'ideaEvaluation'
    const currentSection = ideaSteps[currentIdeaDetailsIndex];

    if (currentSection === 'ideaEvaluation') {
      // Dispatch action to set validation to true when on Idea Evaluation page
      dispatch(setValiditedFalse());
    } else {
      // Dispatch action to set validation to false when on other pages
      dispatch(setValiditedFalse());
    }
  }, [currentIdeaDetailsIndex, dispatch, ideaSteps]);

  // Existing effect for automatic navigation when validated

  // local data save of idea
  useEffect(() => {
    const existData = ideaExistData ? JSON.parse(ideaExistData) : null;
    if (existData) {
      setEditIdeaFormValues(existData)
      StorageUtils.set('ideahubdetails', null)
    }
  }, [])

  return (
    // <div className="idea-details">
    //   <div className="idea-details__actions">
    //     <IdeaDetailsActions
    //       idea={idea}
    //       ideaStatus={ideaStatus}
    //       ideaCollaborationType={ideaCollaborationType}
    //       currentIdeaDetailsSection={ideaSteps[currentIdeaDetailsIndex]}
    //       ideaRatedByUser={ideaRatedByUser}
    //       submitButtonRef={submitButtonRef}
    //       ideaSharedFor={ideaSharedFor}
    //       handleNext={handleNext}
    //       handleSave={handleSave}
    //       handleDiscard={handleDiscard}
    //     />
    //   </div>
    //   <div className="idea-details__sub-sections">
    //     <Card className="idea-details__sub-sections__menu">
    //       {ideaDetailsSections.map(({ label, key }, index) => {
    //         const isActive: boolean = ideaSteps[currentIdeaDetailsIndex] === key;
    //         return (
    //           <LeftMenu
    //             key={key}
    //             state={isActive ? 'active' : 'default'}
    //             onClick={() => {
    //               console.log('index', index);
    //               setCurrentIdeaDetailsIndex(index);
    //             }}
    //             className="idea-details__sub-sections__menu__item"
    //           >
    //             <Typography as="p" variant="body-2" fontWeight="medium">
    //               {label}
    //             </Typography>
    //           </LeftMenu>
    //         );
    //       })}
    //     </Card>
    //     <div className="idea-details__sub-sections__component">{currentIdeaDetailsComponent}</div>
    //   </div>
    // </div>
    <>
      <div className="idea-details">
        <div className="idea-details__actions">
          <IdeaDetailsActions
            idea={idea}
            ideaStatus={ideaStatus}
            ideaCollaborationType={ideaCollaborationType}
            currentIdeaDetailsSection={ideaSteps[currentIdeaDetailsIndex]}
            ideaRatedByUser={ideaRatedByUser}
            submitButtonRef={submitButtonRef}
            ideaSharedFor={ideaSharedFor}
            handleNext={handleNext}
            handleSave={handleSave}
            handleDiscard={handleDiscard}
          />
        </div>
        <div className="idea-details__sub-sections">
          <Card className="idea-details__sub-sections__menu">
            {ideaDetailsSections.map(({ label, key }, index) => {
              const isActive: boolean = ideaSteps[currentIdeaDetailsIndex] === key;
              return (
                <LeftMenu
                  key={key}
                  state={isActive ? 'active' : 'default'}
                  onClick={() => {
                    console.log('index', index);
                    setCurrentIdeaDetailsIndex(index);
                  }}
                  className="idea-details__sub-sections__menu__item"
                >
                  <Typography as="p" variant="body-2" fontWeight="medium">
                    {label}
                  </Typography>
                </LeftMenu>
              );
            })}
          </Card>
          <div className="idea-details__sub-sections__component">{currentIdeaDetailsComponent}</div>
        </div>
      </div>
      <ConfirmModal
        title=""
        description={<p style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', margin: '0' }}>
          <span>To enjoy all the features of <span style={{ color: '#fa4616' }}>htraction</span> </span>
          <span><span style={{ color: '#fa4616' }}>Sign in</span> to Continue</span>
        </p>}
        openConfirmModal={show}
        onClose={() => setShow(false)}
        onSubmit={handleNavigate}
        submitText="Sign in"
        type="confirm"
      />
    </>
  );
};

export default IdeaDetails;
